import { castParam, LocaleComponent } from '~/services/router-helper'
import Footer from '#/layout/Footer.vue'

export default [
    {
        path: '*',
        redirect: '/orders'
    },
    {
        path: '/',
        name: 'Home',
        redirect: { name: 'Orders' }
    },
    {
        path: '/login',
        name: 'Login',
        components: { default: () => import(/* webpackChunkName: "Login" */ '#/views/auth/Login.vue') },
        meta: { requiresAuth: false }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        components: { default: () => import(/* webpackChunkName: "ForgotPassword" */ '~/views/ForgotPassword.vue') },
        meta: { requiresAuth: false }
    },
    {
        path: '/password-reset/:uidb64/:token',
        name: 'PasswordReset',
        component: () => import(/* webpackChunkName: "PasswordReset" */ '~/views/PasswordReset.vue'),
        meta: { requiresAuth: false },
        props: true,
        caseSensitive: true
    },
    {
        path: '/activation/:confirmKey',
        name: 'Activation',
        components: { default: () => import(/* webpackChunkName: "Activation" */ '~/views/Activation.vue') },
        meta: { requiresAuth: false },
        props: { default: true }
    },
    {
        path: '/orders',
        components: { default: LocaleComponent, footer: Footer },
        children: [
            {
                path: '/',
                name: 'Orders',
                components: { default: () => import(/* webpackChunkName: "Orders" */ '#/views/Orders.vue') },
                meta: { requiresAuth: true }
            },
            {
                path: ':orderId',
                name: 'Order',
                components: { default: () => import(/* webpackChunkName: "Order" */ '#/views/Order.vue') },
                meta: { requiresAuth: true },
                props: { default: castParam }
            }
        ]
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        components: { default: () => import(/* webpackChunkName: "PrivacyPolicy" */ '#/views/PrivacyPolicy.vue'), footer: Footer },
        meta: { requiresAuth: false }
    },
    {
        path: '/checkout/init-stripe-session/:orderId',
        name: 'InitStripeSession',
        components: { default: () => import(/* webpackChunkName: "InitStripeSession" */ '#/views/checkout/InitStripeSession.vue') },
        meta: { requiresAuth: false },
        props: { default: castParam }
    },
    // alipay
    {
        path: '/checkout/init-alipay-source/:orderId',
        name: 'InitAlipaySource',
        components: { default: () => import(/* webpackChunkName: "InitAlipay" */ '#/views/checkout/InitAlipay.vue') },
        meta: { requiresAuth: false },
        props: { default: castParam }
    },
    {
        path: '/checkout/finish-alipay/:orderId',
        name: 'FinishAlipay',
        components: { default: () => import(/* webpackChunkName: "FinishAlipay" */ '#/views/checkout/FinishAlipay.vue') },
        meta: { requiresAuth: false },
        props: { default: castParam }
    },
    // paypal
    {
        path: '/checkout/init-paypal/:orderId',
        name: 'InitPayPal',
        components: { default: () => import(/* webpackChunkName: "InitPayPal" */ '#/views/checkout/InitPayPal.vue') },
        meta: { requiresAuth: false },
        props: { default: castParam }
    },
    {
        path: '/checkout/finish-paypal/:orderId',
        name: 'FinishPayPal',
        components: { default: () => import(/* webpackChunkName: "FinishPayPal" */ '#/views/checkout/FinishPayPal.vue') },
        meta: { requiresAuth: false },
        props: { default: castParam }
    },
    {
        path: '/checkout/success/:orderId',
        name: 'CheckoutSuccess',
        components: { default: () => import(/* webpackChunkName: "Success" */ '#/views/checkout/Success.vue') },
        meta: { requiresAuth: false },
        props: { default: castParam }
    },
    {
        path: '/checkout/cancel',
        name: 'CheckoutCancel',
        components: { default: () => import(/* webpackChunkName: "Cancel" */ '#/views/checkout/Cancel.vue') },
        meta: { requiresAuth: false }
    }
    // {
    //     path: '/about',
    //     name: 'about',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '#/views/About.vue')
    // }
]
